export default __webpack_public_path__ + "static/media/Failed.deb09868.svg";